import React from "react";
import { useTranslation } from "react-i18next";

import { Team } from "./Team";
import { Gallery } from "./gallery";
import { PageTitle } from "./pageTitle";
import { GridElements } from "./gridelements";
import JsonData from "../data/data.json";
import "../App.css";

const Account = () => {
  const { t } = useTranslation("account");
  const { t: tLanding } = useTranslation("landing");
  const brand = JsonData?.About?.nameBank || "COFISA";
  const gridData = { line: tLanding("gridElements", { returnObjects: true }) };

  return (
    <>
      <PageTitle
        title={t("title")}
        sub={t("sub", { brand })}
        sub2={t("sub2")}
      />
      <GridElements data={gridData} />
      <Team />
      <Gallery />
    </>
  );
};

export default Account;
